import { SvgProps } from "../../utils/types";

export default function RecordIcon({ stroke }: SvgProps) {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.0882 9L16.5 5.5V12.5L12.0882 9ZM12.0882 9V5.5C12.0882 4.5335 11.2982 3.75 10.3235 3.75H3.26471C2.29009 3.75 1.5 4.5335 1.5 5.5V12.5C1.5 13.4665 2.29009 14.25 3.26471 14.25H10.3235C11.2982 14.25 12.0882 13.4665 12.0882 12.5V9Z"
                stroke={stroke || "#33363B"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
